import { render, staticRenderFns } from "./liberdadeRCad.vue?vue&type=template&id=3ba17f12&scoped=true"
import script from "./liberdadeRCad.vue?vue&type=script&lang=js"
export * from "./liberdadeRCad.vue?vue&type=script&lang=js"
import style0 from "./liberdadeRCad.vue?vue&type=style&index=0&id=3ba17f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba17f12",
  null
  
)

export default component.exports